var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.828 3.196l5.976 5.976a4 4 0 0 1 0 5.656l-5.976 5.976a4 4 0 0 1-5.656 0l-5.976-5.976a4 4 0 0 1 0-5.656l5.976-5.976a4 4 0 0 1 5.656 0zm1.687 11.98l-3.049-3.05 3.049-3.001c.154-.139.154-.285 0-.44l-.855-.877a.313.313 0 0 0-.23-.092.449.449 0 0 0-.232.092l-3.025 3.002-3.025-3.002a.313.313 0 0 0-.231-.092.449.449 0 0 0-.231.092l-.855.878c-.154.154-.154.308 0 .462l3.049 3.002-3.049 3.025a.313.313 0 0 0-.092.231c0 .093.03.17.092.231l.878.855a.313.313 0 0 0 .23.092c.078 0 .147-.03.209-.092l3.025-3.026 3.025 3.026a.313.313 0 0 0 .231.092c.077 0 .147-.03.208-.092l.878-.855a.313.313 0 0 0 .092-.23c0-.093-.03-.17-.092-.232z",
    id: "a"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-64.9%",
    y: "-54.9%",
    width: "229.8%",
    height: "229.8%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.607892215 0 0 0 0 0.607803345 0 0 0 0 0.607922554 0 0 0 0.139917346 0",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.787d928b.svg";
export { ForwardRef as ReactComponent };